const prefix = "NOTES_";

export const LIST = prefix + "LIST";
export const EDIT_DELETE = prefix + "EDIT_DELETE";
export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
